/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import i18n from '@/i18n'

const priceRules = [
  v => /^[0-9]+\.{0,1}[0-9]{0,2}$/.test(v) || i18n.t('pls_enter_the_correct_price')
]

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start'
    },
    formConfig: {
      requiredNew: false
    },
    form: false,
    header: false
  },
  PLZArea: {
    displayName: 'DeliveryRangeOrKM',
    formConfig: {
      hint: 'DeliveryRangeHint'
    }
  },
  priceMod: {
    type: IKDataEntity.Types.Float,
    displayName: 'DeliveryCosts',
    formConfig: {
      rule: priceRules
    }
  },
  startPrice: {

    type: IKDataEntity.Types.Float,
    displayName: 'startPrice',
    formConfig: {
      rule: priceRules,
      hint: 'MinimumOrderValueHint'
    }
  },
  freePrice: {
    type: IKDataEntity.Types.Float,
    displayName: 'freePrice',
    formConfig: {
      rule: priceRules,
      hint: 'FreeDeliveryHint'
    }
  }
}
const config = {
  add: function (item) {
    item.name = item.PLZArea
    return hillo.post('Takeaway.php?op=addDeliveryArea', item, {
      showLoading: true
    })
  },
  edit: function (item) {
    return hillo.postWithUploadFile('Takeaway.php?op=updateDeliveryArea', item, {
      showLoading: true
    })
  },
  remove: function (id) {
    return hillo.post('Takeaway.php?op=deleteDeliveryArea', { id })
  },
  load: async function (filter) {
    return (await hillo.get('Takeaway.php?op=showAllDeliveryArea', { ...filter }))
      .content
  }
}
export default IKDataEntity.ModelFactory(entity, config)
